// extracted by mini-css-extract-plugin
export var fadeInOut = "_3a-3";
export var icon = "_3a-4";
export var savedIndicator = "_3a-2";
export var savingIndicator = "_3a-0";
export var spin = "_3a-1";